/*
 * LocaleToggle Messages
 *
 * This contains all the text for the LanguageToggle component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  en: {
    id: 'boilerplate.containers.LocaleToggle.en',
    defaultMessage: 'en',
  },
  de: {
    id: 'boilerplate.containers.LocaleToggle.de',
    defaultMessage: 'de',
  },
});
